export default "__VITE_ASSET__f6313bb0__"